import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuthContext } from '@/contexts/AuthContext';
import { updateUserSubscriptionTier } from '@/lib/stripe/services/subscription';

export function SuccessPage() {
  const navigate = useNavigate();
  const { user } = useAuthContext();

  useEffect(() => {
    const handleSubscriptionUpdate = async () => {
      if (user) {
        try {
          // Update user's subscription tier to "BASIC"
          await updateUserSubscriptionTier(user.uid, 'BASIC');
          
          // Redirect to profile after successful update
          const timer = setTimeout(() => {
            navigate('/profile');
          }, 5000);
          
          return () => clearTimeout(timer);
        } catch (error) {
          console.error('Failed to update subscription:', error);
        }
      }
    };

    handleSubscriptionUpdate();
  }, [user, navigate]);

  return (
    <div className="min-h-screen pt-32 pb-16 px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-md mx-auto text-center"
      >
        <div className="mb-8">
          <CheckCircle className="w-16 h-16 text-green-500 mx-auto" />
        </div>
        <h1 className="text-3xl font-bold mb-4">Payment Successful!</h1>
        <p className="text-gray-600 mb-8">
          Thank you for your purchase. Your Basic subscription has been activated.
        </p>
        <Button onClick={() => navigate('/profile')}>
          Go to Profile
        </Button>
      </motion.div>
    </div>
  );
}